import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Help = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 2C8.275 2 2 8.275 2 16C2 23.725 8.275 30 16 30C23.725 30 30 23.725 30 16C30 8.275 23.725 2 16 2ZM25.163 23.75L22.326 20.913C23.376 19.55 24.001 17.85 24.001 16C24.001 14.15 23.376 12.45 22.313 11.1L25.163 8.25C26.938 10.338 28 13.05 28 16C28 18.95 26.925 21.65 25.163 23.75V23.75ZM10 16C10 12.687 12.688 10 16 10C19.312 10 22 12.688 22 16C22 19.312 19.312 22 16 22C12.688 22 10 19.312 10 16ZM23.75 6.838L20.913 9.676C19.55 8.626 17.85 8.001 16 8.001C14.15 8.001 12.45 8.626 11.1 9.689L8.25 6.839C10.35 5.076 13.05 4.001 16 4.001C18.95 4.001 21.65 5.076 23.75 6.839V6.838ZM6.838 8.25L9.676 11.088C8.626 12.451 8.001 14.151 8.001 16C8.001 17.849 8.626 19.55 9.689 20.9L6.839 23.75C5.076 21.65 4.001 18.95 4.001 16C4.001 13.05 5.076 10.35 6.839 8.25H6.838ZM8.25 25.163L11.088 22.326C12.451 23.376 14.151 24.001 16 24.001C17.849 24.001 19.55 23.376 20.9 22.313L23.737 25.15C21.65 26.925 18.937 27.987 15.987 27.987C13.049 27.999 10.35 26.924 8.249 25.162L8.25 25.163Z" />
	</svg>
);

export default Help;
